import { ApiReservation, parseSpecialRequests } from '../../services/reservationService';
import { addDays } from '../dateUtils';
import { AnalysisStay } from './types';

/**
 * Normalize raw API reservations into AnalysisStay records.
 * Keeps every version/status (cancelled and superseded rows are needed by
 * the cancellation and anomaly analyses); callers filter with
 * isRevenueStay() for revenue/occupancy math.
 */
export function normalizeReservations(apiReservations: ApiReservation[]): AnalysisStay[] {
  return apiReservations.map(res => {
    const checkIn = res.check_in.split('T')[0];
    return {
      id: res.id,
      confirmationCode: res.confirmation_code || '',
      checkIn,
      checkOut: addDays(checkIn, res.days),
      days: res.days,
      cost: res.cost,
      status: res.status,
      createdAt: res.created_at,
      memberId: res.member_id ?? undefined,
      customerId: res.customer_id ?? undefined,
      adults: res.adult,
      children: res.child,
      pets: res.pet,
      vehicles: res.vehicle,
      isCurrentVersion: res.is_current_version !== false,
      supersededByReservationId: res.superseded_by_reservation_id,
      supersedesReservationId: res.supersedes_reservation_id,
      hasPaymentLink: parseSpecialRequests(res.special_requests).payment_type === 'payment_link',
      sites: (res.reservation_sites || []).map(rs => ({
        siteId: rs.site_id,
        siteAlias: rs.site?.alias || `Site ${rs.site_id}`,
        siteCost: rs.site_cost,
        status: rs.status,
        cancelledAt: rs.cancelled_at,
        cancellationReason: rs.cancellation_reason,
        addedAfterBooking: rs.added_after_booking ?? false,
      })),
    };
  });
}
